import { memo, ReactNode } from 'react';
import { Chip, ChipProps } from '@mui/material';

export type StatusType = 'pending' | 'approved' | 'denied' | 'success' | 'warning' | 'error' | 'info' | 'default';

export interface StatusChipProps {
  status: StatusType;
  label: string;
  icon?: ReactNode;
  size?: ChipProps['size'];
  variant?: ChipProps['variant'];
}

const statusColors: Record<StatusType, ChipProps['color']> = {
  pending: 'warning',
  approved: 'success',
  denied: 'error',
  success: 'success',
  warning: 'warning',
  error: 'error',
  info: 'info',
  default: 'default',
};

/**
 * Reusable status chip with semantic colors
 */
export const StatusChip = memo<StatusChipProps>(({
  status,
  label,
  icon,
  size = 'small',
  variant = 'filled',
}) => (
  <Chip
    size={size}
    variant={variant}
    label={label}
    color={statusColors[status]}
    icon={icon as React.ReactElement | undefined}
  />
));

StatusChip.displayName = 'StatusChip';

export default StatusChip;
